import styled from "styled-components";

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: #357ED3;
`;
